const Leads = [
  {
    to_name: "Prarthana Chandak",
    to_email: "prarthanachandak@gmail.com",
  },
  {
    to_name: "Ashish Patil",
    to_email: "ashishpatil96579@gmail.com",
  },
  {
    to_name: "Shrinivas Khond",
    to_email: "skhond32@gmail.com",
  },
  {
    to_name: "Shrinivas Khond",
    to_email: "skhond32@gmail.com",
  },
  {
    to_name: "Harshal Raundal",
    to_email: "harshraundal00@gmail.com",
  },
  {
    to_name: "Parth Desai",
    to_email: "parthraj1001@gmail.com",
  },
  {
    to_name: "Akshada Bhandari",
    to_email: "akshada3654@gmail.com",
  },
  {
    to_name: "Omkar Danave Patil",
    to_email: "omkar.danave@aissmsioit.org",
  },
];

export default Leads;
